export interface PasswordResetTokenStatus {
  valid: boolean;
}
